import ToolbarButton from "../toolbar/ToolbarButton";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNotes } from "../../api/notes";
import dayjs from "dayjs";
import { Filter } from "../layerControl/FilterModal";
import { applyFilters } from "../../utils/layerFilters";

const NotesLayer = (id: string, name: string, filters: Filter[] = []) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { notes } = useNotes(projectId);
  const [geojson, setGeojson] = useState<any>(null);
  const [active, setActive] = useState(true);
  const [stale, setStale] = useState(false);

  useEffect(() => {
    if (notes && notes.data) {
      const baseGeojson = {
        type: "FeatureCollection",
        features: notes.data.map((note: any) => ({
          type: "Feature",
          id: note.id,
          geometry: {
            type: "Point",
            coordinates: [note.lng, note.lat],
          },
          properties: {
            id: note.id,
            full_text: note.full_text,
            dateAdded: note.dateAdded,
            photoUrl: note.photoUrl,
            hoverLabel: dayjs(note.dateAdded).format("DD MMM YYYY"),
          },
        })),
      };
      
      // Apply user filters
      const filtered = applyFilters(baseGeojson, filters);
      
      setGeojson(filtered);
      setStale(true);
    }
  }, [notes, filters]);

  // basic circle style
  const layerStyle = {
    id: id,
    type: "circle" as const,
    paint: {
      "circle-color": "#00d4ad",
      "circle-radius": 6,
      "circle-stroke-color": "#ffffff",
      "circle-stroke-width": 1,
    },
  };

  const toolbarButton = (
    <ToolbarButton
      key={id}
      id={id}
      name={name}
      toggledOn={active}
      enabled={!!geojson}
      onClick={() => setActive(!active)}
      icon={"chat"}
    />
  );

  return {
    id: id,
    name: name,
    source: geojson,
    rawSource: geojson,
    layerStyle: layerStyle,
    toolbarButton: toolbarButton,
    active: active,
    stale,
    setStale,
  };
};

export default NotesLayer;
